import { SearchItem } from './module';

export const GovernmentTradeSearchModuleId = 'Government Traders' as const;

// V1

export interface GovernmentTradeSearchItemDataV1 {
  governmentMemberId: string;
  governmentMemberName: string;
}

export const GovernmentTradeSearchItemVersionV1 = '1' as const;

export interface GovernmentTradeSearchItemV1 extends SearchItem<GovernmentTradeSearchItemDataV1> {
  version: typeof GovernmentTradeSearchItemVersionV1;
  moduleId: typeof GovernmentTradeSearchModuleId;
}

export type LegacyGovernmentTradeSearchItem = GovernmentTradeSearchItemV1;

// Current

export type GovernmentTradeSearchItemData = GovernmentTradeSearchItemDataV1;

export const GovernmentTradeSearchItemVersion = GovernmentTradeSearchItemVersionV1;

export type GovernmentTradeSearchItem = GovernmentTradeSearchItemV1;

export const GovernmentTradeItemSpecifier = '&';

export const createGovernmentTradeSearchItem = (
  governmentMemberId: string,
  governmentMemberName: string,
): GovernmentTradeSearchItem => ({
  data: {
    governmentMemberId: governmentMemberId,
    governmentMemberName: governmentMemberName,
  },
  id: governmentMemberId,
  moduleId: GovernmentTradeSearchModuleId,
  version: GovernmentTradeSearchItemVersion,
});

export const isLegacyGovernmentTradeSearchItem = (item: SearchItem): item is LegacyGovernmentTradeSearchItem =>
  item.moduleId === GovernmentTradeSearchModuleId;

export const isGovernmentTradeSearchItem = (item: SearchItem): item is GovernmentTradeSearchItem =>
  item.moduleId === GovernmentTradeSearchModuleId && item.version === GovernmentTradeSearchItemVersion;
